// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3-mnA","errors":"Errors_errors__tJjFp"};